<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">推送管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <el-select v-model="timeType" placeholder="Select" style="width: 8em; margin-right: 4px;">
            <el-option v-for="item in timeTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <DatePickerRange title="" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>VIP：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>新用户：</label>
          <el-select v-model="newUserState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in newUserStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>开启状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>推送状态：</label>
          <el-select v-model="pushState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in pushStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editPushDialog(-1)">新建推送</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="pushTime" label="推送时间" v-if="checkColList.indexOf('推送时间') > -1" ></el-table-column>
          <el-table-column property="" label="条件" v-if="checkColList.indexOf('条件') > -1">
            <template #default="scope">
              <p>性别：{{scope.row.sex == 0?'通用':scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}</p>
              <p>VIP状态：{{scope.row.vipState == 0?'通用':scope.row.vipState == 1?'vip':scope.row.vipState == 2?'非vip':scope.row.vipState == 3?'vip已失效':''}}</p>
              <p>新用户：{{scope.row.newUserState == 0?'通用':scope.row.newUserState == 1?'旧用户':scope.row.newUserState == 2?'新用户':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="title" label="推送标题" v-if="checkColList.indexOf('推送标题') > -1"></el-table-column>
          <el-table-column property="content" label="推送内容" v-if="checkColList.indexOf('推送内容') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':''}}</p>
              <p>{{ currentTime > scope.row._pushTime && scope.row.pushNum > 0?'已推送':'待推送'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editPushDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">启用</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="danger" v-show="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">停用</el-button>
                <el-button size="small" @click="editPushDialog(-2,scope.row)" type="warning">复用</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getPushPageList, updatePushState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import PushDialog from "./components/PushDialog";
import DatePickerRange from '../../components/DatePickerRange'

export default {
  name: "ChatGreeting",
  components: { BtnGroup, DatePickerRange },
  data() {
    return {

      timeTypeArray: [
        {label: '创建时间', value: 1},
        {label: '推送时间', value: 2}
      ],
      timeType: 1,

      //IM/纸条时间
      startTime: '',
      endTime: '',
      isChecked: true,

      sexArray: [
        {label: '不限', value: -1},
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      vipStateArray: [
        {label: '不限', value: -1},
        {label: '通用', value: 0},
        {label: 'vip', value: 1},
        {label: '非vip', value: 2},
        {label: 'vip已失效', value: 3},
      ],
      vipState: -1,

      newUserStateArray: [
        {label: '不限', value: -1},
        {label: '通用', value: 0},
        {label: '旧用户', value: 1},
        {label: '新用户', value: 2},
      ],
      newUserState: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2},
      ],
      state: -1,

      pushStateArray: [
        {label: '不限', value: -1},
        {label: '待推送', value: 0},
        {label: '已推送', value: 1},
      ],
      pushState: -1,

      //刷新组
      colList: ['创建时间', '推送时间', '条件','推送标题', '推送内容', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      currentTime: '',

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.timeType = 1;
      this.sex = -1;
      this.vipState = -1;
      this.newUserState = -1;
      this.state = -1;
      this.pushState = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['timeType'] = this.timeType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['vipState'] = this.vipState;
      param['newUserState'] = this.newUserState;
      param['pushState'] = this.pushState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPushPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.currentTime = new Date().getTime()
          this.pageDataList.map(item => {
            item._pushTime = new Date(item.pushTime).getTime()
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editPushDialog(idx, row) {
      let _title = '';
      let pushForm = {}
      if (idx > -1) {
        _title = '推送内容设置'
        pushForm = Object.assign({}, row);
      }else {
        _title = '新建推送内容'
        if(idx == -2) {
          pushForm = Object.assign({}, row);
        }
      }
      Dialog.open({
        title: _title,
        component: PushDialog,
        data: {
          pushForm: pushForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updatePushState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.pageDataList[idx].state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
